import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useLazyLoadImage } from 'tmt-ui-kit';

import { path } from '~/utils/media';

const Container = styled.div`
  position: relative;
  padding-bottom: 75%;
`;

const ArticleCardContainer = styled.div`
  color: ${props => props.theme.black};
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
`;

const ArticleImage = styled.img`
  display: block;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  transition: ${props => props.theme.imageTransition};
`;

const TitleContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const ArticleTitle = styled.p`
  color: ${props => props.theme.white};
  font-weight: 500;
  font-size: 28px;
  text-align: center;
  line-height: 32px;
`;

const ArticleNormalStyleCard = props => {
  const { data } = props;
  const imgRef = useRef();
  useLazyLoadImage(imgRef);
  return (
    <Container>
      <ArticleCardContainer>
        <ArticleImage
          ref={imgRef}
          src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
          data-src={data.thumbnail_image ? path(data.thumbnail_image, 'rectangle-310-233') : ''}
          data-srcSet={data.thumbnail_image ? path(data.thumbnail_image, 'rectangle-620-466') : ''}
          alt={data.title}
        />
        <TitleContainer className="title-container">
          <ArticleTitle className="article-title">{data.title}</ArticleTitle>
        </TitleContainer>
      </ArticleCardContainer>
    </Container>
  );
};

ArticleNormalStyleCard.propTypes = {
  data: PropTypes.object,
};

export default ArticleNormalStyleCard;
